export enum ClientTemplateCodes {
  CPROD_OVERVIEW = "contract_product_overview"
}
